import { components } from '@/utils'

const className = 'groupButton'
const iconSize = 20

function renderIndicator(h) {
  return h(
    'div',
    {
      class: `${className}__indicator`,
      style: this.indicatorStyles,
      ref: 'indicator'
    }
  )
}

function renderButtonContent(h, item) {
  if (item.icon) {
    return h(
      components.icon,
      {
        props: {
          value: item.icon,
          size: iconSize
        }
      }
    )
  }

  return item.label
}

function renderButton(h, item, index) {
  return h(
    'div',
    {
      class: {
        [`${className}__button`]: true,
        [`${className}__button--disabled`]: !!item.disabled,
        [`${className}__button--current`]: index === this.currentIndex,
        [`${className}__button--${item.color}`]: index === this.currentIndex
      },
      on: {
        click: () => {
          return this.buttonClickHandler(item)
        }
      },
      ref: 'buttons',
      refInFor: true
    },
    [ renderButtonContent(h, item) ]
  )
}

function renderHolder(h) {
  return h(
    'div',
    {
      class: `${className}__holder`,
      ref: 'holder'
    },
    [
      renderIndicator.call(this, h),
      renderItems.call(this, h)
    ]
  )
}

function renderItems(h) {
  return this.$_items.map((item, index) => {
    return renderButton.call(this, h, item, index)
  })
}

export default function(h) {
  return h(
    'div',
    {
      class: this.classes
    },
    [ renderHolder.call(this, h) ]
  )
}
